import { __awaiter, __generator } from "tslib";
var DEFAULT_LANGUAGE = 'en';
var createConfig = function (language) {
    var _a;
    return ({
        lng: language,
        resources: (_a = {},
            _a[language] = {
                translation: require("../locale/messages_en.json"),
            },
            _a),
    });
};
export var getTranslationFunction = function (i18n, language) {
    if (language === void 0) { language = DEFAULT_LANGUAGE; }
    return __awaiter(void 0, void 0, void 0, function () {
        var i18nInstance;
        return __generator(this, function (_a) {
            i18nInstance = i18n.createInstance();
            return [2 /*return*/, i18nInstance.init(createConfig(language))];
        });
    });
};
//# sourceMappingURL=i18n.js.map